import React from "react";
import CityField from "../CityField";

export function addressValidationError(edit, confirmed) {
  if (!confirmed) return "Seleziona una città dall’elenco";
  if (!edit?.street?.trim()) return "Indirizzo (via e civico) obbligatorio";
  return "";
}

export default function AddressFields({ edit, setEdit, addrCityConfirmed, setAddrCityConfirmed, idPrefix }) {
  return <><div className="prf-field prf-col-12">
                            <label htmlFor={`${idPrefix}-field-8`}>
                              Etichetta
                            </label>
                            <input
                              id={`${idPrefix}-field-8`}
                              value={edit?.label || ""}
                              onChange={(e) =>
                                setEdit((s) => ({
                                  ...s,
                                  label: e.target.value,
                                }))
                              }
                              placeholder="Casa, Ufficio…"
                            />
                          </div>

                          <div className="prf-field prf-col-12">
                            <label htmlFor={`${idPrefix}-field-9`}>
                              Indirizzo (via e civico)
                            </label>
                            <input
                              id={`${idPrefix}-field-9`}
                              value={edit?.street || ""}
                              onChange={(e) =>
                                setEdit((s) => ({
                                  ...s,
                                  street: e.target.value,
                                }))
                              }
                              placeholder="Es. Via Roma 12"
                              required
                              className="prf-input"
                            />
                          </div>

                          <div className="prf-row-inline prf-row-inline--addr-capcity">
                            <div className="prf-field prf-field--cap">
                              <label htmlFor={`${idPrefix}-field-10`}>
                                CAP
                              </label>
                              <input
                                id={`${idPrefix}-field-10`}
                                value={edit?.cap || ""}
                                onChange={(e) =>
                                  setEdit((s) => ({
                                    ...s,
                                    cap: e.target.value
                                      .replace(/\D/g, "")
                                      .slice(0, 5),
                                  }))
                                }
                                className="prf-input"
                              />
                            </div>

                            <div className="prf-field prf-field--city">
                              <CityField
                                label="Città"
                                value={edit?.citta || ""}
                                provinciaValue={edit?.provincia || ""}
                                capValue={edit?.cap || ""}
                                hardConfirm={true}
                                confirmed={addrCityConfirmed}
                                setConfirmed={setAddrCityConfirmed}
                                onChangeCity={(v) => {
                                  setEdit((s) => ({
                                    ...s,
                                    citta: v,
                                    provincia: "",
                                  }));
                                  setAddrCityConfirmed(false);
                                }}
                                onApplyCity={({ name, provincia, cap }) => {
                                  setEdit((s) => ({
                                    ...s,
                                    citta: name,
                                    provincia,
                                    cap: cap || s.cap || "",
                                  }));
                                  setAddrCityConfirmed(true);
                                }}
                                inputClassName="prf-input"
                                showEmptyHint
                              />
                            </div>

                            <div className="prf-field prf-field--prov">
                              <label htmlFor={`${idPrefix}-field-11`}>
                                Provincia
                              </label>
                              <input
                                id={`${idPrefix}-field-11`}
                                value={edit?.provincia || ""}
                                readOnly
                                className="prf-input"
                                placeholder="es. MO"
                              />
                            </div>
                          </div>

                          <div className="prf-row-inline prf-row-inline--addr-phonenotes">
                            <div className="prf-field prf-field--phone">
                              <label htmlFor={`${idPrefix}-field-12`}>
                                Telefono
                              </label>
                              <input
                                id={`${idPrefix}-field-12`}
                                value={edit?.phone || ""}
                                onChange={(e) =>
                                  setEdit((s) => ({
                                    ...s,
                                    phone: e.target.value,
                                  }))
                                }
                                className="prf-input"
                              />
                            </div>

                            <div className="prf-field prf-field--notes">
                              <label htmlFor={`${idPrefix}-field-13`}>
                                Note
                              </label>
                              <input
                                id={`${idPrefix}-field-13`}
                                value={edit?.notes || ""}
                                onChange={(e) =>
                                  setEdit((s) => ({
                                    ...s,
                                    notes: e.target.value,
                                  }))
                                }
                                className="prf-input"
                                placeholder="Citofono, piano, ecc."
                              />
                            </div>
                          </div>

                          <div className="prf-col-12">
                            <label className="prf-check">
                              <input
                                type="checkbox"
                                checked={!!edit?.active}
                                onChange={(e) =>
                                  setEdit((s) => ({
                                    ...s,
                                    active: e.target.checked,
                                  }))
                                }
                              />
                              Imposta come indirizzo attivo
                            </label>
                          </div>

                          </>;
}
